<div
	class="accessible-skip-link"
	*ngFor="let option of options">
	<a
		*ngIf="option.domElement"
		role="link"
		class="goreact-btn primary-btn skip-link-btn"
		href="#{{option.id}}">{{option.linkText}}</a>
</div>
